import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deleteViewModalHeader: {
    description: 'deleteFilterViewModal.title',
    defaultMessage: 'Delete View',
    id: 'pyAXu4',
  },
  cancelButtonText: {
    description: 'deleteFilterViewModal.cancel',
    defaultMessage: 'Cancel',
    id: 'N42XNu',
  },
  deleteButtonText: {
    description: 'deleteFilterViewModal.saveView',
    defaultMessage: 'Delete View',
    id: '+LlzWm',
  },
  deleteViewConfirmationMessage: {
    description: 'deleteFilterViewModal.prompt',
    defaultMessage: 'Are you sure you want to delete the view {viewName}? This action cannot be done.',
    id: 'xYZNHI',
  },
});
